import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { ContactMeta, CreateContactInput, UpdateContactInput } from '@bom/shared';
import { api } from '../lib/apiClient';

/** 通知联系人（无系统帐号的关系人）：tenant 成员可读、admin 可写 */
export function useContacts(tid: string | undefined) {
  return useQuery({
    queryKey: ['contacts', tid],
    queryFn: () =>
      api.get<{ contacts: ContactMeta[] }>(`/tenants/${tid}/contacts`).then((r) => r.contacts),
    enabled: !!tid,
  });
}

export function useCreateContact(tid: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateContactInput) =>
      api.post<{ id: string }>(`/tenants/${tid}/contacts`, input),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['contacts', tid] }),
  });
}

export function useUpdateContact(tid: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { cid: string; body: UpdateContactInput }) =>
      api.patch<void>(`/tenants/${tid}/contacts/${vars.cid}`, vars.body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['contacts', tid] }),
  });
}

export function useDeleteContact(tid: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (cid: string) => api.del<void>(`/tenants/${tid}/contacts/${cid}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['contacts', tid] }),
  });
}
